import { useMutation } from '@tanstack/react-query';
import { getAllOffices } from '@/api/office';
import { OfficeData } from "@/types";
import { PostParam } from "@/types";

export function useGetAllOffices(props?: PostParam) {
    const { onSuccess, onError } = props || {};

    return useMutation<OfficeData[], Error>({
        mutationFn: getAllOffices,
        onSuccess,
        onError
    });
}
